import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import "./AnyBonus.css"; // unaweza kutumia style zako

export default function UserBonusList({ username: propUsername }) {
  const [bonuses, setBonuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("");

  useEffect(() => {
    // Pata username kutoka localStorage au prop
    const storedUsername = propUsername || localStorage.getItem("username");
    if (storedUsername) {
      const lowerName = storedUsername.trim().toLowerCase(); // ✅ normalize
      setUsername(lowerName);
      fetchBonuses(lowerName);
    } else {
      setLoading(false);
    }
  }, [propUsername]);

  const fetchBonuses = async (uname) => {
    try {
      setLoading(true);

      // 🔍 Query kwa username ya lowercase
      const q = query(
        collection(db, "bonusHistory"),
        where("username", "==", uname),
        orderBy("date", "desc")
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setBonuses([]);
      } else {
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBonuses(list);
      }
    } catch (err) {
      console.error("❌ Tatizo wakati wa kusoma bonus:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p>⏳ Inapakia taarifa zako...</p>;
  }

  if (!username) {
    return <p>⚠️ Tafadhali login kwanza kuona bonus zako.</p>;
  }

  if (bonuses.length === 0) {
    return <p>😢 Bado hujapata bonus yeyote hadi sasa.</p>;
  }

  return (
    <div className="bonus-container">
      <h3>🎁 Bonus Zako ({username})</h3>
      <table className="bonus-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Kiasi (TSH)</th>
            <th>Kiasi (USDT)</th>
            <th>Sababu</th>
            <th>Tarehe</th>
          </tr>
        </thead>
        <tbody>
          {bonuses.map((b, i) => (
            <tr key={b.id}>
              <td>{i + 1}</td>
              <td>{b.bonusTsh?.toLocaleString() || "-"}</td>
              <td>{b.bonusUsdt || "-"}</td>
              <td>{b.reason || "—"}</td>
              <td>
                {b.date?.toDate
                  ? b.date.toDate().toLocaleString()
                  : new Date(b.date).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}